<template>
  <div class="container text-center">
    <div class="form-signin">
      <img :src="require('@/assets/images/icon.png')" alt="icon" id="icon">
      
      <button 
        class="btn btn-lg btn-primary btn-block" 
        @click="handleLogin" 
        :disabled="isLoading"
        id="submit"
      >
        {{ isLoading ? 'Redirecting...' : 'Sign in with Okta' }}
      </button>
      
      <div v-if="error" class="alert alert-danger mt-3" role="alert">
        {{ error }}
      </div>
    </div>
    
    <p class="mt-5 mb-3 text-muted">Marketing Cost Manager &copy; 2024</p>
  </div>
</template>

<script>
import tokenManagerService from "../services/tokenManager";

export default {
  name: 'SigninPage',
  data() {
    return {
      error: null,
      isLoading: false
    };
  },
  
  async mounted() {
    this.handleUrlErrors();

    try {
      const token = await tokenManagerService.getValidToken();
      if (token) {
        console.log("✅ User already has a valid session, redirecting home...");
        this.$router.replace('/');
      }
    } catch (e) {
      // Ignore error, just stay on login page
    }
  },

  methods: {
    handleUrlErrors() {
      const urlParams = new URLSearchParams(window.location.search);
      const errorType = urlParams.get('error');
      
      if (!errorType) return;

      const errors = {
        'session_expired': 'Your session has expired. Please log in again.',
        'login_failed': 'Authentication failed. Please try again.',
        'auth_flow_error': 'There was an issue connecting to Okta. Please try again.',
        'interaction_required': 'Please log in to continue.'
      };

      this.error = errors[errorType] || 'An unknown error occurred.';
    },

    async handleLogin() {
      this.isLoading = true;
      this.error = null;
      
      try {
        console.log("🔐 Initiating login redirect...");
        await tokenManagerService.login(); 
      } catch (error) {
        console.error("❌ Login redirection failed:", error);
        this.error = "Could not connect to identity provider.";
        this.isLoading = false;
      }
    },
  }
};
</script>

<style scoped>
  html {
    min-height: 100%;
  }

  .errorBox {
    color: red
  }

  body {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #f5f5f5;
  }

  #icon {
    width: 250px;
    margin-bottom: 50px;
  }

  .form-signin {
    width: 100%;
    max-width: 330px;
    padding: 15px;
    margin: auto;
  }
  
  .alert {
    font-size: 0.9rem;
    padding: 0.75rem 1.25rem;
    margin-bottom: 1rem;
    border: 1px solid transparent;
    border-radius: 0.25rem;
  }
  
  .alert-danger {
    color: #721c24;
    background-color: #f8d7da;
    border-color: #f5c6cb;
  }
</style>
